import { render, staticRenderFns } from "./exhibition-activity-home.vue?vue&type=template&id=62ed0a95&scoped=true&"
import script from "./exhibition-activity-home.vue?vue&type=script&lang=js&"
export * from "./exhibition-activity-home.vue?vue&type=script&lang=js&"
import style0 from "./exhibition-activity-home.vue?vue&type=style&index=0&id=62ed0a95&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62ed0a95",
  null
  
)

export default component.exports